(ns dashboard.components.navbar
  (:require
   [reagent.core :as reagent]
   [clojure.string :refer [split lower-case blank?]]
   [re-frame.core :as re-frame]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.components.profile :refer [profile-img]]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen href cs ->ns-first]]
   [dashboard.events.auth0 :as auth0]
   ["@heroicons/react/outline" :refer [XIcon MenuIcon BellIcon BookOpenIcon]]))

(defn- tab
  [{:keys [route path-params query-params title class]
    :or {path-params {:space-id (listen ::subs/selected-space-id)}
         query-params {}}}]
  (let [is-active? (= route (listen ::subs/current-route-name))]
    [:a.px-3.py-2.text-white.focus:outline-none.focus:ring-2.focus:ring-primary-800
     {:class (cs ""
                 (when (some? class) class)
                 (if is-active?
                   "bg-black bg-opacity-25 text-white rounded-md text-sm font-medium"
                   "hover:bg-primary-800 hover:text-white rounded-md text-sm font-medium"))
      :aria-current (when is-active? "page")
      :href (href route path-params (or query-params (listen ::subs/current-route-query-params)))}
     title]))

(defn- mobile-tab
  [{:keys [route path-params query-params title class]
    :or {path-params {:space-id (listen ::subs/selected-space-id)}
         query-params {}}}]
  (let [is-active? (= route (listen ::subs/current-route-name))]
    [:a.px-3.py-2.text-white
     {:class (cs ""
                 (when (some? class) class)
                 (if is-active?
                   "bg-black bg-opacity-25 block rounded-md text-base font-medium"
                   "hover:bg-primary-800 hover:text-white block rounded-md text-base font-medium"))
      :aria-current (when is-active? "page")
      :href (href route path-params (or query-params (listen ::subs/current-route-query-params)))}
     title]))

(def main-navigation-routes
  [:route.home/home
   :route.rooms/rooms])

(defn nav []
  [ui/disclosure
   {:as :nav}
   (fn [{:keys [open]}]
     [:<>
      [:div.max-w-7xl.mx-auto.sm:px-6.lg:px-8
       [:div.lg:border-b.lg:border-gray-800
        [:div.flex.items-center.justify-between.h-16.px-4.sm:px-0
         [:div.flex.items-center
          [:div.flex-shrink-0
           [:img.h-8
            {:alt (listen ::subs/company-name)
             :src (listen ::subs/logo)}]]
          [:div.hidden.md:block
           [:div.ml-10.flex.items-baseline.space-x-4
            (doall
             (for [route-key main-navigation-routes
                   :let [title (tr (-> (listen :route-for route-key) :data :title))
                         query-params (-> (listen :route-for route-key) :data :default-query-params)
                         resource (-> (listen :route-for route-key) :data :resource)]
                   :when (if (some? resource)
                           (some? ((into #{} (map :resource (:permissions (listen ::subs/user-role)))) resource))
                           true)]
               ^{:key route-key}
               [tab
                {:route route-key
                 :query-params query-params
                 :title title}]))]]]
         [:div.hidden.md:block
          [:div.ml-4.flex.items-center.md:ml-6
           [:button.p-1.text-primary-50.rounded-full.hover:bg-primary-600.hover:text-white.focus:outline-none.focus:ring-2.focus:ring-primary-800
            {:type "button"}
            [:span.sr-only "View notifications"]
            [:> BellIcon
             {:class "h-6 w-6"
              :aria-hidden true}]]
           #_[:button.p-1.text-primary-50.rounded-full.hover:bg-primary-600.hover:text-white.focus:outline-none.focus:ring-2.focus:ring-primary-800
            {:type "button"
             :on-click #(re-frame/dispatch [:show-user-guide :default])}
            [:span.sr-only "View user guide"]
            [:> BookOpenIcon
             {:class "h-6 w-6"
              :aria-hidden true}]]

           ;; Profile image with menu
           [:div.ml-3.relative
            [:div
             [ui/menu
              [ui/menu-button
               {:class "max-w-xs bg-dark-grey1 flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-primary-800"}
               [:span.sr-only "Open Menu"]
               [profile-img
                {:class (cs "h-8 w-8"
                            (when (> (count (:lastNameJp (listen ::subs/userinfo))) 2)
                              "text-xs"))
                 :src (:profile_picture_url (listen ::subs/userinfo))
                 :text (if (blank? (:lastNameJp (listen ::subs/userinfo)))
                         (str (first (:firstName (listen ::subs/userinfo)))
                              (first (:lastName (listen ::subs/userinfo))))
                         (subs (:lastNameJp (listen ::subs/userinfo)) 0 2))}]]
              [ui/transition
               {:enter "transition ease-out duration-200"
                :enter-from "transform opacity-0 scale-95"
                :enter-to "transform opacity-100 scale-100"
                :leave "transition ease-in duration-75"
                :leave-from "transform opacity-100 scale-100"
                :leave-to "transform opacity-0 scale-95"}
               [ui/menu-items
                {:class "focus:outline-none absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"}
                [:div.px-1.py-1
                 [ui/menu-item
                  (fn [{:keys [active]}]
                    [:a
                     {:class (cs "group flex px-4 py-2 text-sm rounded-md"
                                 (if active
                                   "bg-primary-500 text-white"
                                   "text-black"))
                      :href (href :route.settings/profile)}
                     (tr :settings)])]
                 [ui/menu-item
                  (fn [{:keys [active]}]
                    [:a
                     {:class (cs "group flex px-4 py-2 text-sm rounded-md"
                                 (if active
                                   "bg-primary-500 text-white"
                                   "text-black"))
                      :on-click #(re-frame/dispatch [::auth0/logout])}
                     (tr :action/sign-out)])]]]]]]]]]
         [:div.-mr-2.flex.md:hidden
          ;; Mobile menu button
          [ui/disclosure-button
           {:class "inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-primary-800 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"}
           [:span.sr-only "Open main menu"]
           (if open
             [:> XIcon
              {:class "block h-6 w-6"
               :aria-hidden true}]
             [:> MenuIcon
              {:class "block h-6 w-6"
               :aria-hidden true}])]]]]]

      ;; Mobile menu
      [ui/disclosure-panel
       {:class "border-b border-gray-700 md:hidden"}
       [:div.px-2.py-3.space-y-1.sm:px-3
        (doall
         (for [route-key main-navigation-routes
               :let [title (tr (-> (listen :route-for route-key) :data :title))
                     query-params (-> (listen :route-for route-key) :data :default-query-params)]]
           ^{:key route-key}
           [mobile-tab
            {:route route-key
             :query-params query-params
             :title title}]))]
       [:div.pt-4.pb-3.border-t.border-gray-700
        [:div.flex.items-center.px-5
         [:div.flex-shrink-0
          [profile-img
           {:class (cs "h-10 w-10"
                       (when (> (count (:lastNameJp (listen ::subs/userinfo))) 2)
                         "text-xs"))
            :src (:profile_picture_url (listen ::subs/userinfo))
            :text (if (blank? (:lastNameJp (listen ::subs/userinfo)))
                    (str (first (:firstName (listen ::subs/userinfo)))
                         (first (:lastName (listen ::subs/userinfo))))
                    (subs (:lastNameJp (listen ::subs/userinfo)) 0 3))}]]
         [:div.ml-3.flex-1
          [:div.text-base.font-medium.leading-none.text-white
           (str (:firstName (listen ::subs/userinfo)) " " (:lastName (listen ::subs/userinfo)))]
          [:div.text-sm.font-medium.leading-none.text-gray-200
           (:email (listen ::subs/userinfo))]]
         [:div
          [:button.ml-auto.bg-transparent.flex-shrink-0.p-1.text-gray-200.rounded-full.hover:text-white.focus:outline-none.focus:ring-2.focus:ring-primary-800
           {:type "button"
            :on-click #(re-frame/dispatch [:show-user-guide :default])}
           [:span.sr-only "View user guide"]
           [:> BookOpenIcon
            {:class "h-6 w-6"
             :aria-hidden true}]]
          [:button.ml-auto.bg-transparent.flex-shrink-0.p-1.text-gray-200.rounded-full.hover:text-white.focus:outline-none.focus:ring-2.focus:ring-primary-800
           {:type "button"}
           [:span.sr-only "View notifications"]
           [:> BellIcon
            {:class "h-6 w-6"
             :aria-hidden true}]]]]
        [:div.mt-3.px-2.space-y-1
         [:a.block.px-3.py-2.rounded-md.text-base.font-medium.text-gray-200.hover:text-white.hover:bg-primary-800
          {:href (href :route.settings/profile)}
          (tr :settings)]
         [:a.block.px-3.py-2.rounded-md.text-base.font-medium.text-gray-200.hover:text-white.hover:bg-primary-800
          {:on-click #(re-frame/dispatch [::auth0/do-logout])}
          (tr :action/sign-out)]]]]])])
